import { requireAuth } from '@/router/helpers';

export default [
  {
    path: '/admin/content/',
    redirect: '/admin/content/pages',
  },

  // Pages -> All
  {
    path: '/admin/content/pages',
    name: 'AdminContentPages',
    component: () => import('@/views/admin/Content'),
    beforeEnter: requireAuth,
    props: { tabFilter: 'pages' },
    meta: { isAdmin: true },
  },

  // Page -> Create
  {
    path: '/admin/content/pages/create',
    name: 'AdminContentPageCreate',
    component: () => import('@/views/admin/content/PageEditCreate'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },

  // Page -> Edit
  {
    path: '/admin/content/pages/:pageId/edit',
    name: 'AdminContentPageEdit',
    component: () => import('@/views/admin/content/PageEditCreate'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
];
